export type DashboardLayout = 'classic' | 'v2';

/** V2 es la presentación por defecto; /v1 conserva el diseño anterior. /v2 sigue siendo un alias. */
export const isV2Path = (pathname: string) => !/^\/v1(?:\/|$)/.test(pathname);

/** Cambia de presentación manteniendo oficina, tándem, vista y ancla, sin copiar el token. */
export function layoutHref(layout: DashboardLayout, href: string): string {
  const url = new URL(href);
  url.pathname = layout === 'v2' ? '/' : '/v1/';
  url.searchParams.delete('token');
  return url.pathname + url.search + url.hash;
}
